import { useState } from 'react';

import { useToggle } from '@feathr/hooks';

export const SLIDER_DEFAULT_VALUE = 50;

interface IUseAudience {
  selectedAudience: number;
  isEnabled: boolean;
  toggleIsEnabled: () => void;
  setSelectedAudience: (audience: number) => void;
}

// TODO: Hook this up tot he backend
function useLookalikeAudience(): IUseAudience {
  const [isEnabled, toggleIsEnabled] = useToggle(false);
  const [selectedAudience, setSelectedAudience] = useState<number>(SLIDER_DEFAULT_VALUE);

  return {
    selectedAudience,
    isEnabled,
    toggleIsEnabled,
    setSelectedAudience,
  };
}

export default useLookalikeAudience;
